@if (items()) {
  <ul
    [class.list--big]="isBig()"
    [class.list--open]="isOpen()"
    [class.list--scroll]="isScroll()"
    [ngStyle]="customStyle()"
    [style.--i]="items().length"
    class="list">
    @for (item of items(); track item) {
      <li (click)="selected.emit(item)" class="list-item">
        <span>{{ item.label }}</span>
        @if (item.icon) {
          <i [color]="'WHITE'" [iconName]="item.icon" [size]="'2rem'"></i>
        }
      </li>
    }
  </ul>
}
